import { render } from "./AppPaginate.vue?vue&type=template&id=338a3618"
import script from "./AppPaginate.vue?vue&type=script&lang=js"
export * from "./AppPaginate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__